class PageContentHomeController {

    constructor($state, markdownService, eventsService) {
        this.$state = $state;
        this.marked = markdownService;
        this.eventsService = eventsService;
    }

    $onInit() {
        this.loading = true;
        this.eventsService.collectAll(-1).then(response => {
            this.loading = false;
            this.events = response.filter(event => {
                return event.base_price > 0;
            });
        });
    }

    groupEvents(item) {
        return item.type_display;
    }
}

PageContentHomeController.$inject = [ '$state', 'markdownService', 'eventsService' ];

export default PageContentHomeController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/pageContent/controllers/pageContent.home.controller.js